import { render, staticRenderFns } from "./ContactLensShow.vue?vue&type=template&id=59196246&"
import script from "./ContactLensShow.vue?vue&type=script&lang=js&"
export * from "./ContactLensShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports